import metadata from '@/assets/images/countries/_metadata.json'

type MetadataEntry = {
  countryCode: string
  countryName: string
  photographer: string
  photographerUsername: string
  unsplashUrl: string
}

const imageMap = metadata as Record<string, MetadataEntry>

export function getCountryImageAttribution(
  countryCode: string
): { photographer: string; unsplashUrl: string } | null {
  const data = imageMap[countryCode.toLowerCase()]
  if (!data) return null
  return { photographer: data.photographer, unsplashUrl: data.unsplashUrl }
}

export function getAllAttributions() {
  return Object.values(imageMap).map((data) => ({
    countryCode: data.countryCode,
    countryName: data.countryName,
    photographer: data.photographer,
    photographerUrl: `https://unsplash.com/@${data.photographerUsername}`,
    unsplashUrl: data.unsplashUrl,
  }))
}
